
import { useContext, useState, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { Link } from 'react-router-dom';
import Stack from '@mui/joy/Stack';
import Typography from '@mui/joy/Typography';

import { RootStoreContext } from 'stores/root_store';
import { FHRequestType } from 'stores/fhrequest_store';

import useFHRequest from 'hooks/useFHRequest';
import useWorkKey from 'hooks/useWorkKey';
import { LoreDecorator } from 'components/Lore';
import WorkList from 'components/WorkList';
import useCollabInvite from 'hooks/useCollabInvite';
import useClock from 'hooks/useClock';
import useAuth from 'hooks/useAuth';


function AvailableTitle() {
    return (
        <Stack>
                <Typography level="title-lg"
                    endDecorator={<LoreDecorator slug="assistant/lists/the-big-board" />}
                >
                The Big Board
            </Typography>
            <Typography level="body-xs">
                Find something to work on
            </Typography>
        </Stack>
    );
}

const CombinedRequestAndCollabList = observer(({ paged }: { paged: boolean }) => {
    const store = useContext(RootStoreContext).collabInviteStore;
    const { fetchListAvailable, getListAvailable } = useFHRequest();
    const workKey = useWorkKey();
    const { currentClock } = useClock();
    const { currentUser } = useAuth();
    const { fetchAvailableCollabs } = useCollabInvite();
    const invites = store.getInvitesByStatus('available');

    const [loadingRequests, setLoadingRequests] = useState(false);
    const [requests, setRequests] = useState([] as FHRequestType[]);
    const [fetchedCollabs, setFetchedCollabs] = useState(false);

    // Load collabs
    useEffect(() => {
        if(workKey && !fetchedCollabs && !invites.length) {
            fetchAvailableCollabs(workKey)
                .then(() => {
                    setFetchedCollabs(true);
                });
        }
    }, [workKey, invites.length]);

    // Load requests
    useEffect(() => {
        if (!workKey) return;
        if (loadingRequests) return;

        setLoadingRequests(true);
        fetchListAvailable(workKey).then(() => {
            setLoadingRequests(false);
        });
    }, [fetchListAvailable, workKey]);

    useEffect(() => {
        // console.log("getlistAvailable");
        if (getListAvailable) {
            setRequests(getListAvailable());
        }
    }, [getListAvailable().length]);


    // Let's put the Collabs on top of requests for now.
    const sortedRequests = requests.sort((a, b) =>
        a.date_created > b.date_created ? 1 : -1);
    const sortedInvites = invites.sort((a, b) =>
        a.date_created > b.date_created ? 1 : -1);
    const both = [...sortedInvites, ...sortedRequests];
    // const both = [...requests, ...invites].sort((a, b) =>
    //     a.date_created > b.date_created ? 1 : -1) as WorkItemType[];

    if (currentUser.is_ic && currentClock?.uuid) {
        return (
            <Stack pb={5}>
                <AvailableTitle />

                <Stack my={3}>
                    <em>You cannot claim new tasks while you're clocked in on a <Link to={`/${currentClock.associated_type}/${currentClock.associated_uuid}`}>{currentClock.associated_type}</Link>.</em>

                </Stack>

            </Stack>);
    }

    return <WorkList
               title={<AvailableTitle />}
               items={both}

               loading={loadingRequests}
               paged={paged} />

});

export default CombinedRequestAndCollabList;
